module.exports = __webpack_public_path__ + "static/media/mudey_rating4.ccea179b.svg";